import { CDefine, CEnumTypes } from "./CEnumTypes";
import { CByteArray } from "./CByteArray";
import { CGame } from "./CGame";

export class CMultipleGunSel {
    private m_Game:CGame;
    private m_mcP:fgui.GComponent;
    private m_mcs:Array<fgui.GComponent>;
    private m_cnt:number;
    private m_Value:CByteArray = new CByteArray(16);
    private m_Index:Array<number> = new Array<number>(16);
    private m_Sel:number;

    constructor() {
        this.m_Game = CGame.Instance;
        this.m_Sel = -1;
    }

    public release(callbackFunc:PIXI.utils.EventEmitter.ListenerFn):void {
        this.m_Game.SetGOPartCallbackFunc(this.m_mcP, "mc_btn", 4, callbackFunc, false, this);
        this.m_mcs = null;
    }

    public init(mcP:fgui.GComponent, callbackFunc:PIXI.utils.EventEmitter.ListenerFn):void {
        var mc:fgui.GComponent, i:number;

        this.m_cnt = 0;
        this.m_mcP = mcP;
        this.m_mcs = new Array<fgui.GComponent>();
        for ( i = 0; i < mcP.numChildren; i ++ ) {
            let c = mcP.getChildAt(i);
            if (fgui.utils.StringUtil.startsWith(c.name, "mc_btn")) {
                if( c.name == "mc_btnCancel5" ) {
                    c.visible = true;
                }
                else {
                    c.visible = false;
                    mc = c as fgui.GComponent;
                    this.m_mcs.push(mc);
                }
            }
        }
        this.m_mcP.visible = false;
        this.m_Game.SetGOPartCallbackFunc(this.m_mcP, "mc_btn", 4, callbackFunc, true, this);
    }

    public reset():void {
        var i:number;
        
        this.m_mcP.visible = false;
        for ( i = 0; i < this.m_mcs.length; i ++ ) this.m_mcs[i].visible = false;
        this.m_cnt = 0;
        this.m_Sel = -1;
    }

    public add(v1:number, idx1:number):void {
        var i:number;
        
        for ( i = 0; i < this.m_cnt; i ++ ) {
            if ( this.m_Value[i] == v1 ) return;
        }
        this.m_Value[this.m_cnt] = v1;
        this.m_Index[this.m_cnt] = idx1;
        this.m_cnt ++;
        //trace("****** CMultipleGunSel add:", v1, idx1, m_cnt);
    }
    
    public getValue(idx:number):number { return this.m_Value[idx]; }
    public getIndex(idx:number):number { return this.m_Index[idx]; }
    public getCount():number { return this.m_cnt; }

    public setSel(sel:number):void {
        this.m_Sel = 2000 + sel;
        CGame.DebugLog("*** CMultipleGunSel:", this.m_Sel);
    }
    public getSel():number { return this.m_Sel; }

    public show():void {
        var xs:Array<number> = [140, 450, 0, 10, 270, 530];
        var y:number = 8;
        var mc:fgui.GMovieClip;
        var col:number = 8, row:number = 5, frame:number = 0;
        var i:number, j:number, idx:number = (this.m_cnt - 2) * 3;
        
        for ( i = 0; i < this.m_cnt; i ++ ) {
            this.m_mcs[i].x = xs[idx + i];
            this.m_mcs[i].y = y;
            this.m_mcs[i].visible = true;
            for ( j = 0; j < 4; j ++ ) {
                mc = this.m_mcs[i].getChild("mc_Card" + j) as fgui.GMovieClip;
                row = ((this.m_Value[i] & 0x70) >> 4);
                col = (this.m_Value[i] & 0x0f);
                frame = (row - 1) * 9 + col;
                mc.frame = frame;
            }
        }
        this.m_mcP.visible = true;
    }
}